import React, { createContext, useState, useEffect } from "react";
import { LOGIN_MUTATION, GET_USER, LOGOUT_MUTATION } from "schema/auth";
import { useLazyQuery, useMutation } from "@apollo/client";
import notify from "utils/toast";
import history from "utils/history";
import { isEmpty } from "lodash";
import { decodeToken } from "utils/auth";

export const AuthContext = createContext({});

export default function AuthContextProvider({ children }) {
  const user = localStorage?.wrn_admin_de
    ? JSON.parse(localStorage?.wrn_admin_de)
    : {};
  const [isAuthenticated, setIsAuthenticated] = useState(!isEmpty(user));
  const [me, setMe] = useState(user);
  const [login, { data: LoginData, loading: loadingLogin }] = useMutation(
    LOGIN_MUTATION
  ); // error
  const [meQuery, { data: meData, loading: meLoading }] = useLazyQuery(
    GET_USER
  );
  const [logout, { data: logoutData, loading: logoutLoading }] = useMutation(
    LOGOUT_MUTATION
  );

  useEffect(() => {
    if (meData) {
      const {
        me: { error, data },
      } = meData;
      if (error) {
        notify(error[0].message, "error");
        localStorage.removeItem("wrn_admin_de");
        localStorage.removeItem("wrn_data_entry_token");
        setIsAuthenticated(false);
      } else {
        let newData = { ...data, role: data.role.role_id, role_: data.role };

        if (data?.profile_pic && data?.profile_pic?.blob) {
          const b64 = new Buffer(data.profile_pic.blob.data).toString("base64");
          const imageUri = `data:${data.profile_pic.mimetype};base64,${b64}`;
          newData = { ...newData, profile_pic: imageUri };
        }
        if (data?.identification && data?.identification?.blob) {
          const b64 = new Buffer(data.identification.blob.data).toString(
            "base64"
          );
          const imageUri = `data:${data.identification.mimetype};base64,${b64}`;
          newData = { ...newData, identification: imageUri };
        }
        setMe(newData);
        localStorage.setItem("wrn_admin_de", JSON.stringify(newData));
      }
    }
  }, [meData]);

  useEffect(() => {
    if (LoginData) {
      const {
        login: { error, token },
      } = LoginData;
      if (error) {
        notify(error[0].message, "error");
      } else {
        const token_data = decodeToken(token);
        meQuery();
        localStorage.setItem("wrn_admin_de", JSON.stringify(token_data));
        localStorage.setItem("wrn_data_entry_token", token);
        notify("Welcome back 👋", "reg.success");
        setTimeout(() => {
          history.push("/app");
          window.location.reload();
        }, 2000);
      }
    }
  }, [LoginData]);

  useEffect(() => {
    if (logoutData) {
      localStorage.removeItem("wrn_admin_de");
      localStorage.removeItem("wrn_data_entry_token");
      notify("bye 👋", "reg.success");
      setTimeout(() => window.location.reload(), 1000);
    }
  }, [logoutData]);

  return (
    <AuthContext.Provider
      value={{
        login,
        logout,
        me,
        meQuery,
        logoutLoading,
        meLoading,
        loading: loadingLogin,
        isAuthenticated,
        setIsAuthenticated,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}
